$('body').removeClass('no-js');
//Initialize Accordion
new Accordion(".accordion-container");

//Carousel Script
//document.querySelectorAll(".glide__slides")
if (document.querySelector(".glide__slides")) {

    var allSlides = document.querySelectorAll(".glide");
    allSlidesArray = Array.prototype.slice.call(allSlides);
    allSlidesArray.forEach((slide) => {

        const glide = new Glide(slide, {
            type: "slider",
            perView: 1,
            perTouch: 1,
            focusAt: 'center',
            autoplay: false,
            accessibility: true,
            startAt: 2,
            rewind: false,
            classes: {
                disabledArrow: 'glide__arrow--disabled'
            },
            perSwipe: "|",
            breakpoints: {
                800: {
                    perView: 1,

                }
            }
        }).mount();

    });
};

// $('.glide__arrow--right').on('click', function () {
//   $('.glide__arrow--right').removeClass('disabled');

//   var totalslides = $('.glide__bullet').length;

//   if ($('.glide__bullet')[totalslides - 1].hasClass('glide__bullet--active')) {
//     console.log('last');
//     $('.glide__arrow--right').addClass('disabled');
//   }
// })

//Check if Header Button link is external
if (document.querySelector('.cta-btn')) {
    let currentHost = window.location.hostname;
    let ctaBtn = document.querySelector('.cta-btn');
    let ctaLink = ctaBtn.getAttribute("href").split('/');

    if (ctaLink[0] !== currentHost) {
        ctaBtn.classList.add("external-link");
    }
}

//Menu
$(document).ready(function () {
    "use strict";
    $('.menu-main-menu-container > ul > li:has( > ul)').addClass('menu-dropdown-icon');
    $('.menu-main-menu-container > ul > li > ul:not(:has(ul))').addClass('normal-sub');
    $(".menu-main-menu-container > ul").before("<div class=\"container\"><a href=\"#\" class=\"menu-mobile\"><span></span><span class=\"screen-reader-text\">Menu Toggle</span></a><span class=\"menu-span\">Menu</span></div>");
    $(".menu-main-menu-container > ul > li").hover(function (e) {
        if ($(window).width() > 943) {
            $(this).children("ul").stop(true, false).fadeToggle(150).attr('aria-expanded', true);
            e.preventDefault();
        }
    });


    $(".menu-main-menu-container > ul > li").click(function () {
        if ($(window).width() <= 943) {
            //$(this).children("ul").fadeToggle(150);
        }
    });
    $(".menu-mobile, .menu-span").click(function (e) {
        $(".menu-main-menu-container > ul").toggleClass('show-on-mobile');
        $(".menu-mobile").toggleClass('active-menu');
        $("#overlay").fadeToggle();
        $('body').toggleClass('no-scroll');

        if ($(".menu-mobile").hasClass('active-menu') == true) {
            var menuFromTop = $('.show-on-mobile').offset().top;
            $('.show-on-mobile').css('height', 'calc(100vh - ' + menuFromTop + 'px)');
            $('.menu-span').text('Close');
        } else {
            $('.menu-span').text('Menu');
        }

        e.preventDefault();
    });
});
$(window).resize(function () {
    $(".menu-main-menu-container > ul > li").children("ul").hide();
    $(".menu-main-menu-container > ul").removeClass('show-on-mobile');
});

let menuSubmenu = document.querySelectorAll('.menu-item-has-children');
let allmenuSubmenu = Array.prototype.slice.call(menuSubmenu);
allmenuSubmenu.forEach((menu) => {

    let parentName = menu.firstChild.textContent;

    menu.children[0].setAttribute('aria-haspopup', 'true');
    menu.children[1].setAttribute('aria-expanded', false);
    menu.children[1].setAttribute('aria-label', parentName + ' Submenu');
});

var spanChevron = $('<span />').attr('class', 'arrowchevron').attr('tabindex', 0);
$('.menu-item-has-children > a').append(spanChevron);

$('.menu-item-has-children > a').each(function () {
    var arrw = $(this).find('.arrowchevron');
    var pname = $(this).text();
    arrw.text('Open submenu for ' + pname);
});

$('.menu-item-has-children > a').on('click', function (e) {
    // console.log('link clicked');
    // if ($(this).next().css('display') == 'none') {
    //   e.preventDefault();
    //   $(this).closest('.arrowchevron').addClass('close-submenu');
    // } else {
    //   $(this).closest('.arrowchevron').removeClass('close-submenu');
    // }
})

$('.arrowchevron').on('keypress click', function (e) {
    console.log('chevron clicked');
    $(this).parent().next().fadeToggle(150);
    $(this).toggleClass('close-submenu');

    // if ($(this).parent().next().css('display') == 'none') {
    //   $('.arrowchevron').addClass('close-submenu');
    // } else {
    //   $('.arrowchevron').removeClass('close-submenu');
    // }
    e.preventDefault();
});

////Pagination 
if (document.querySelector(".navigation-pagination")) {
    let paginationList = document.querySelectorAll('.navigation-pagination ul li');

    if (paginationList[0].classList.contains("active")) {
        paginationList[0].style.position = "relative";
    }

    if (paginationList[paginationList.length - 1].classList.contains("active")) {
        paginationList[paginationList.length - 1].style.position = "relative";
    }
}


////////Masonary
if (document.querySelector('.allcontainer')) {
    var elem = document.querySelector('.allcontainer');
    var msnry = new Masonry(elem, {
        // options
        itemSelector: '.item',
        columnWidth: '.grid-sizer',
        gutter: 15,
    });

    //Filters
    // const filterBtn = document.querySelectorAll('.filters button');    
    // var allfilterBtn = Array.prototype.slice.call(filterBtn);
    //let allblocks = document.querySelectorAll('.item');
    let allblocks = Array.prototype.slice.call(document.querySelectorAll('.item'));
    let selectedValue;
    let selectedOption;
    let availableItems;
    let buttons = document.querySelectorAll('.filters button'); //returns a nodelist

    for (let i = 0; i < buttons.length; i++) {
        buttons[i].addEventListener("click", onClickChange);
    }

    //Click Filter
    function onClickChange() {
        selectedValue = this.value;

        // if(selectedValue !== 'all'){
        //   allblocks = document.querySelectorAll('.item.block');
        // }
        allblocks.forEach(function (block) {
            block.classList.remove('block');

            if (selectedValue == 'all') {
                block.classList.add('block');
            }

            if (block.getAttribute('data-cat') == selectedValue) {
                block.classList.add('block');
            }
        });
        msnry.layout();

        availableItems = Array.prototype.slice.call(document.querySelectorAll('.item.block'));
        document.getElementById('select').addEventListener("change", onSelectChange);

    }


    availableItems = Array.prototype.slice.call(document.querySelectorAll('.item.block'));

    document.getElementById('select').addEventListener("change", onSelectChange);

    function onSelectChange() {
        selectedOption = this.value;

        availableItems.forEach(function (item) {
            item.classList.remove('block');

            if (selectedOption == 'all') {
                item.classList.add('block');
            }

            if (item.getAttribute('data-tag') == selectedOption) {
                item.classList.add('block');
            }
        });

        //Filter Click
        for (let i = 0; i < buttons.length; i++) {
            buttons[i].addEventListener("click", onClickChange);
        }

        msnry.layout();
    }

    /////Script_AJAX
    /* Ajax functions */
    $(document).ready(function () {
        //onclick
        $("#loadMore").on('click', function (e) {
            e.preventDefault();
            //init
            var that = $(this);
            var page = $(this).data('page');
            var newPage = page + 1;
            var ajaxurl = that.data('url');
            //ajax call
            $.ajax({
                url: ajaxurl,
                type: 'post',
                data: {
                    page: page,
                    action: 'ajax_script_load_more'

                },
                error: function (response) {
                    console.log(response);
                },
                success: function (response) {
                    //check
                    if (response == 0) {
                        $('.allcontainer').append('<div class="text-center no-more-post"><h4>You reached the end of the line!</h4><p>No more posts to load.</p></div>');
                        $('#loadMore').hide();
                    } else {
                        that.data('page', newPage);
                        $('#ajax-primary').append(response);

                        msnry = new Masonry(elem, {
                            // options
                            itemSelector: '.item',
                            columnWidth: '.grid-sizer',
                            gutter: 15,
                        });

                        msnry.layout();
                    }

                }
            });

        });
    });
}

$('#onetrust-group-container').on('click', 'button', function () {
    $('.skip-link').blur();
    $('.custom-logo-link').focus();
});

//Button Custom Colors Hover
var customBtn = $('.wp-block-button a.has-text-color.has-background');

customBtn.each(function (index) {
    var btnbgColor = $(this).css('backgroundColor');
    var btnColor = $(this).css('color');
    console.log(btnbgColor);

    $(this).mouseenter(function () {
        $(this).css({ "background-color": btnColor, "color": btnbgColor, "border-color": btnColor });
    }).mouseleave(function () {
        $(this).css({ "background-color": btnbgColor, "color": btnColor, "border-color": btnbgColor });
    });;
});

//Our people
if (!(navigator.userAgent.match(/Trident/))) {
    $(document).on("click touchstart", ".our-people", function (e) {
        e.preventDefault();
        $(this).addClass('active-panel');
        $(".our-people--content--row").css('display', 'none');
        $(".our-people--content__desktop").css('display', 'none');
        $(".our-people--content__desktop").attr('aria-expand', 'false');
        var t = $(this).closest(".our-people").attr("data-id");
        if ($(window).width() > 600) {
            $(".our-people--content--row[data-id='" + t + "']").closest('.our-people--content__desktop').slideDown(500).css('display', 'grid');
            $(".our-people--content--row[data-id='" + t + "']").closest('.our-people--content__desktop').attr('aria-expand', 'true');
        }
        $(".our-people--content--row[data-id='" + t + "']").css('display', 'block');
        $(".our-people--content--row[data-id='" + t + "']").find('.our-people--details--btn').focus();

        $("html, body").animate({ scrollTop: $(this).closest(".our-people").offset().top - 15 }, 500),
            $(document).on("click touchstart", ".our-people--content--row .our-people--details--btn", function () {
                $(".our-people--content--row").slideUp(500);
                $(".our-people").removeClass("inactive");
                $(".our-people--content__desktop").attr('aria-expand', 'false');
                $(".our-people.active-panel a").focus();
            });
    });
}

$('.filter-group').on('change', function () {
    document.forms['searchbox-form'].submit();
});

if (!!(navigator.userAgent.match(/Trident/) && navigator.userAgent.match(/rv[ :]11/))) {
    var imgTiles = Array.prototype.slice.call(document.querySelectorAll('.tile-with-img'));

    imgTiles.forEach(tile => {
        var tileImgUrl = tile.children[0].getAttribute('src');
        tile.style.backgroundImage = 'url(' + tileImgUrl + ')';
        tile.removeChild(tile.children[0]);
    })
}

//Current Focus Elemet
let focusedElement;
document.addEventListener('keydown', currentFocusedElement)

function currentFocusedElement() {
    // var abc = document.querySelector('.focusedElement');
    // abc.classList.remove("focusedElement");


    focusedElement = document.activeElement;
    //focusedElement.classList.add('focusedElement');
    sessionStorage.setItem('focusedElement', focusedElement);
}

// window.addEventListener("load", function () {
//     //console.log(sessionStorage.focusedElement);
//     //sessionStorage.focusedElement.focus();
// });



if ($('.peopleFilter').length > 0) {
    var url_string = window.location.href;
    var url = new URL(url_string);
    var roleUrl = url.searchParams.get("role");
    var locationUrl = url.searchParams.get("location");

    if (locationUrl != null && locationUrl != '' && roleUrl == '') {
        $('#filter_location').focus();
    } else if (roleUrl != null && roleUrl != '' && localStorage != null && locationUrl != '') {
        $('#filter_location').focus();
    } else if (roleUrl != null) {
        $('#filter_jobtitle').focus();
    }
}
